import React from 'react'
import ArrowUpSortIcon from "../../../assets/ArrowUpSortIcon";
import ArrowDownSortIcon from "../../../assets/ArrowDownSortIcon";
import ChevronsUpDownIcon from "../../../assets/ChevronsUpDownIcon";
import "./styles.css"

const TableHeaderSort = ({ isActive, direction }) => {
    return (
        <React.Fragment>
            {isActive ? (
                direction === 'asc' ? (
                    <ArrowUpSortIcon height="18" />
                ) : (
                    <ArrowDownSortIcon height="18" />
                )
            ) : (
                <ChevronsUpDownIcon className={'chevron-icon'} height="16" />
            )}
        </React.Fragment>
    )
}

export default TableHeaderSort



// WEBPACK FOOTER //
// ./src/components-new/Table/TableHeaderSort/index.jsx